export enum Roles {
  Administrator = "Administrator",
  Adjuster = "Adjuster",
  CaseManager = "CaseManager",
  Guest = "Guest",
  Investigator = "Investigator",
  Secretary = "Secretary",
}
